const HEIGHTS = {
  header: 63,
  mobileHeader: 45,
  scrollToHeader: 156,
  mobileScrollToHeader: 56,
};

export { HEIGHTS };
